module.exports = __webpack_public_path__ + "img/webdown.6f5868c8.png";